<template>
  <div class="cm-container">
    <codemirror
      v-if="readonly"
      v-model="modelComp"
      :options="cmOptions"
      :enabled="readonly"
    />
    <b-form-textarea v-else v-model="modelComp" style="height: 10rem" readonly />
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/monokai.css";
import "codemirror/mode/python/python";
import "codemirror/theme/xq-light.css";
import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/selection/active-line";
import "codemirror/addon/edit/matchbrackets";
import "codemirror/addon/fold/indent-fold";

export default {
  name: "CustomCodemirror",
  props: {
    model: String,
    readonly: Boolean,
  },
  components: {
    codemirror,
  },
  data() {
    return {
      myCodeMirror: null,
      cmOptions: {
        mode: "python",
        theme: "monokai",
        lineNumbers: true,
        line: true,
        autoCloseBrackets: true,
        smartIndent: true,
        styleSelectedText: true,
        styleActiveLine: true,
        lineWrapping: true,
      },
    };
  },
  computed: {
    modelComp: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      },
    },
  },
  mounted() {
    if (!this.$store.state.darkmode) {
      this.cmOptions.theme = "xq-light";
    }
  },
};
</script>

<style>
.CodeMirror {
  height: 500px;
  border-radius: 15px;
}
</style>
